import { useState, useEffect } from 'react'
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import axios from 'axios';

// User defined Components
import Navbar from './navbar/navBar';
import Homepage from './homepage/homePage';
import Dashboard from './dashboard/dashboard';
import LoginPage from './login/loginPage';
import LogoutPage from './logout/logoutPage';
import RegisterPage from './register/registerPage';
import AddDevice from './dashboard/addDevice/addDevice';
import ProfilePage from './profile/profilePage';
import NotificationsPage from './notifcations/notificationsPage';
import NotFound from './NotFound/notFound';
import Footer from './footer/footer';
import RemoteCtrlPage from './dashboard/remoteCtrlPage/remoteCtrlPage';
import ControlPanel from './dashboard/controlPanel/controlPanelPage';
// import { getCookie } from './utils/cookieManagement.js';

function App() {

  const [auth, setAuth] = useState(null);

  useEffect(() => {
    let intervalId = null;

    const getCookie = (name) => {
      const match = document.cookie
        .split("; ")
        .find((row) => row.startsWith(name + "="));
    
      if (!match) return null; // Return null if cookie not found

      try {
        const rawValue = match.split("=")[1];
        // console.log(`Raw cookie value for ${name}:`, rawValue);
        return decodeURIComponent(rawValue); // Properly decode it
      } catch (error) {
        console.error(`Error decoding cookie ${name}:`, error);
        return null; // Return null if decoding fails
      }
    };

    const clearCookies = () => {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        const [name] = cookie.split("=");
        document.cookie = `${name}=; path=/; domain=commandcenter.ddns.net; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
      }
    };

    const verifyToken = async () => {
      try {
        const loginToken = getCookie("data");
        // console.log(loginToken);
        if (!loginToken) {
          // console.log("no login token");
          clearCookies();
          setAuth(false);
          // window.location.href = "/login"; // Redirect to login page
          return;
        }

        const { data } = await axios.post(
          `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/auth/logintoken`,
          { loginToken },
          { withCredentials: true }
        );

        if (data.status !== "SUCCESS") {
          console.log('login token invalid');
          clearCookies();
          setAuth(false);
          alert("Login Session has expired, please login again.");
          window.location.href = "/login";
        } else {
          console.log("login token valid");
          setAuth(true);
          // ADD expireAfter 10 minute check here
          const targetDate = new Date(data.expiresAfter);
          const now = Date.now();
          const diffMs = targetDate - now;
          const diffMinutes = Math.floor(diffMs / (1000 * 60));
          // console.log(`Difference: ${diffMinutes} minute(s)`); 
          const refresh = localStorage.getItem('refresh');
          if(diffMinutes <= 10 && refresh === 'true') {
            const isRefresh = confirm(`You have ${diffMinutes} minutes left in your current session, would you like to continue?`);
            if(isRefresh) {
              await axios.post(
                `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/auth/refreshtoken`,
                { loginToken },
                { withCredentials: true }
              );
            } else {
              console.log("Refresh set to false");
              localStorage.setItem('refresh', 'false');
            }
          }
        }
      } catch (error) {
        console.error("Error verifying login token:", error);
        // clearCookies();
        setAuth(false);
        // window.location.href = "/login";
      }
    };

    verifyToken();
    intervalId = setInterval(() => { verifyToken(); }, 60000);

    // Clean up function for unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  // If not logged in
  if(auth === false) {
    return (
      <>
        <Navbar />
        <Router>
          <Routes>
            <Route path='/' element={<Homepage />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/register' element={<RegisterPage />} />
            <Route path='/notfound' element={<NotFound />} /> 
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Router>
        <Footer />
      </>
    );
  }

  // Logged In
  if (auth) {
    return (
      <>
        <Navbar/>
        <Router>
          <Routes>
              <Route index element={<Homepage />} />
              <Route path='/dashboard' element={<Dashboard />} />
              <Route path='dashboard/add/computer' element={<AddDevice type={"computer"}/>}/>
              <Route path='dashboard/add/iotdevice' element={<AddDevice type={"IoT Device"}/>}/>
              <Route path='/dashboard/controlpanel/:id' element={<ControlPanel/>}/>
              <Route path='/profile' element={<ProfilePage/>}/>
              <Route path='/notfound' element={<NotFound />} /> 
              <Route path='/logout' element={<LogoutPage />} />
              <Route path='/notifications' element={<NotificationsPage />} />
              <Route path='/dashboard/rdp/:id' element={<RemoteCtrlPage/>}/>
              <Route path='*' element={<NotFound />} />
          </Routes>
        </Router>
        <Footer/>
      </>
    );
  }
}

export default App
